import { render, staticRenderFns } from "./property-griddb.vue?vue&type=template&id=422ad6d1"
import script from "./property-griddb.vue?vue&type=script&lang=js"
export * from "./property-griddb.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports